import { AudienceGraphql } from '../../../generated/apollo-hooks';

export type AudienceOption = { id: string; value: string; label: string; size: number };

export const selectedValueForAudience = (audience: AudienceGraphql): AudienceOption => ({
    id: audience.id,
    value: audience.title,
    label: audience.title,
    size: audience.size
});

export const getAudiencesOptions = (ids: string[], audiences: AudienceGraphql[]): AudienceOption[] => {
    return ids
        ?.map(id => audiences?.find?.(item => id == item.id))
        .filter((it): it is AudienceGraphql => !!it)
        .map(selectedValueForAudience);
};
